// THIS FILE IS GENERATED, DO NOT EDIT!
/* eslint-disable */
import * as Types from '@h5s/dtos-api';

import { LocalDate, LocalDateTime, LocalTime } from '@h5s/util-date';
import { gql } from 'apollo-angular';
export type CashRegisterConfigurablePaymentFragment = { __typename?: 'CashRegisterConfigurablePaymentDTO', type: Types.CashRegisterPaymentTypeEnumDto, description: string };

export const CashRegisterConfigurablePaymentFragment = gql`
    fragment CashRegisterConfigurablePayment on CashRegisterConfigurablePaymentDTO {
  type
  description
}
    `;
/* eslint-enable */